import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investors-icon',
  templateUrl: './investors-icon.component.html',
  styles: []
})
export class InvestorsIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
